export default {
    component: 'header_components',
    name: 'header_components',
    fields: [{
        param: 'plant_id',
        type: 'number',
        required: true,
        identifier: true,
        hidden: true
      },
      {
        name: 'Components',
        param: 'components',
        type: 'json',
        description: `> Need to add in json structure
        - e.g. -> [{"name": "EM Generation", "unit": "kWh", "module": "generation"}, {"name": "PR", "unit": "%", "module": "pr"}, {"name": "GHI Insolation", "unit": "kWh/m²", "module": "ghi"}, {"name": "Wind Speed", "unit": "km/h", "module": "wind_speed"}, {"name": "Temperature", "unit": "°C", "module": "temperature"}, {"name": "PoA Insolation", "unit": "kWh/m²", "module": "poa"}]
        > Option are as follows:
        - {"name": "EM Generation", "unit": "kWh", "module": "generation"}
        - {"name": "PR", "unit": "%", "module": "pr"}
        - {"name": "GHI Insolation", "unit": "kWh/m²", "module": "ghi"}
        - {"name": "Wind Speed", "unit": "km/h", "module": "wind_speed"}
        - {"name": "Temperature", "unit": "°C", "module": "temperature"}
        - {"name": "PoA Insolation", "unit": "kWh/m²", "module": "poa"}`
      }
    ]
  }
